import {
  START_EXPERIMENTS_SIMULATION
} from '../actionTypes';

export const startSweepExtraction = (experimentIds) => ({
  type: START_EXPERIMENTS_SIMULATION,
  experimentIds
})